import { IconButton, useTheme } from "@material-ui/core";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  getMoreBtn: React.ReactNode;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

export default function PaginationActions(props: TablePaginationActionsProps) {
  const { page, count, rowsPerPage, onPageChange, getMoreBtn } = props;
  const theme = useTheme();

  const onFirstPageClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(e, 0);
  };

  const onBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(e, page - 1);
  };

  const onNextClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(e, page + 1);
  };

  const onLastPageClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <>
      {getMoreBtn}
      <div style={{ flexShrink: 0, marginLeft: 10, marginRight: 15 }}>
        <IconButton
          size="small"
          onClick={onFirstPageClick}
          disabled={page === 0}
        >
          {theme.direction === "rtl" && <LastPageIcon />}
          {theme.direction === "ltr" && <FirstPageIcon />}
        </IconButton>
        <IconButton size="small" onClick={onBackClick} disabled={page === 0}>
          {theme.direction === "rtl" && <KeyboardArrowRight />}
          {theme.direction === "ltr" && <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          size="small"
          onClick={onNextClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        >
          {theme.direction === "rtl" && <KeyboardArrowLeft />}
          {theme.direction === "ltr" && <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          size="small"
          onClick={onLastPageClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        >
          {theme.direction === "rtl" && <FirstPageIcon />}
          {theme.direction === "ltr" && <LastPageIcon />}
        </IconButton>
      </div>
    </>
  );
}
